// extracted by mini-css-extract-plugin
export default {"body":"login_body__TAL8M","main":"login_main__69AND","chk":"login_chk__xsjLm","signup":"login_signup__pfCaW","button":"login_button__1w-Qy","login":"login_login__pRp2s"};